import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import INFTProperties, { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { IAvawareAllenCard } from '../Card/IAvawareAllenCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'

export default function AvawareAllenDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IAvawareAllenCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      let newTokenUri = tokenItem.tokenUri.replace('http:', 'https:').replace('https://localhost:3000', 'https://avaware.network')
      if (collection.tokenAddress.toLowerCase() === '0xc6a02823e3001c3c625d77babf299cd76182b174') {
        newTokenUri = newTokenUri.replace('_7', '_8')
      }
      Api.get(newTokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => ({
        key: item.trait_type,
        value: item.value,
        show: true,
        isUrl: false
      }))
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      description={detailTokenItem ? <div>{detailTokenItem.description}</div> : <></>}
      tokenItemName={detailTokenItem ? detailTokenItem.name : ''}
      properites={getNFTProperties()}
    >
      {detailTokenItem ? <img src={detailTokenItem.image} alt={detailTokenItem.name} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
